(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-countdown-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function getEnd(el) {
    var mode = el.dataset.mode;
    var now = Date.now();
    if (mode === 'fixed') {
      var t = Date.parse((el.dataset.end || '').trim().replace(' ', 'T'));
      return isNaN(t) ? now : t;
    }
    if (mode === 'daily') {
      var d = new Date(); d.setHours(24, 0, 0, 0); return d.getTime();
    }
    var len = (parseFloat(el.dataset.hours) || 3) * 3600000;
    var key = el.dataset.key, end = 0;
    try { end = parseInt(localStorage.getItem(key), 10) || 0; } catch (e) {}
    if (!end || end <= now) {
      end = now + len;
      try { localStorage.setItem(key, String(end)); } catch (e) {}
    }
    return end;
  }
  function start(el) {
    if (el.__lpcd) clearInterval(el.__lpcd);
    var end = getEnd(el);
    var dEl = el.querySelector('[data-d]'), hEl = el.querySelector('[data-h]'), mEl = el.querySelector('[data-m]'), sEl = el.querySelector('[data-s]');
    function tick() {
      var diff = Math.max(0, end - Date.now());
      if (diff === 0) {
        if (el.dataset.mode === 'fixed') {
          el.classList.add('is-ended');
          if (el.dataset.hide === 'true' && !window.Shopify?.designMode) el.closest('.shopify-section').style.display = 'none';
          clearInterval(el.__lpcd);
        } else { end = getEnd(el); }
      }
      var sec = Math.floor(diff / 1000);
      var days = Math.floor(sec / 86400);
      var hrs = dEl ? Math.floor((sec % 86400) / 3600) : Math.floor(sec / 3600);
      if (dEl) dEl.textContent = pad(days);
      if (hEl) hEl.textContent = pad(hrs);
      if (mEl) mEl.textContent = pad(Math.floor((sec % 3600) / 60));
      if (sEl) sEl.textContent = pad(sec % 60);
    }
    tick();
    el.__lpcd = setInterval(tick, 1000);
  }
  function init(scope) { (scope || document).querySelectorAll('[data-lp-countdown]').forEach(start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
